// extracted by mini-css-extract-plugin
export default {"item":"GjipToB5ttcZ_PEo6Czd","link":"XHyNt6oPYNO71p2Nej2R"};